{
  "confirmationNumber": "ਪੁਸ਼ਟੀ ਨੰਬਰ {number}",
  "dateTimeRange": "{date} ਨੂੰ {startTime} ਤੋਂ {endTime} ਤੱਕ"
}
